import { createFileRoute } from "@tanstack/react-router";
import * as v from "valibot";
import { KartaView } from "@/lib/features/KartaView";
import { kartaSearchSchema } from "@/lib/schemas/searchParams.schema";
export const Route = createFileRoute("/_app/karta/")({
  component: KartaView,
  validateSearch: search => v.parse(kartaSearchSchema, search)
});